import styled from "styled-components"

export const StyledContainer = styled.section`
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
`